import { ref } from 'vue'
import { defineStore } from 'pinia'
import SetNewPassword from '@/features/auth/ui/modals/SetNewPassword.vue'
import ResetPassword from '@/features/auth/ui/modals/ResetPassword.vue'
import VerifyUser from '@/features/auth/ui/modals/VerifyUser.vue'
import EndOfRegistration from '@/features/auth/ui/modals/EndOfRegistration.vue'
import CheckEmailResetPassword from '@/features/auth/ui/modals/CheckEmailResetPassword.vue'
import ResetPasswordSuccess from '@/features/auth/ui/modals/ResetPasswordSuccess.vue'
import SignInSignUpWrapper from '@/features/auth/ui/modals/SignInSignUpWrapper.vue'

const views = {
  signInSignUpWrapper: SignInSignUpWrapper,
  verifyUser: VerifyUser,
  setNewPassword: SetNewPassword,
  resetPassword: ResetPassword,
  endOfRegistration: EndOfRegistration,
  checkEmailResetPassword: CheckEmailResetPassword,
  resetPasswordSuccess: ResetPasswordSuccess
}

type AuthModalViewKey = keyof typeof views
type AuthModalView = AuthModalViewKey | 'signIn' | 'signUp'

export const useAuthModal = defineStore('authModal', () => {
  const authModal = ref({
    isShow: false,
    isError: false,
    isLoading: false,
    currentView: SignInSignUpWrapper
  })

  const changeViewHandler = (view: AuthModalView) => {
    const mappedView = views[view as AuthModalViewKey] ?? SignInSignUpWrapper
    authModal.value.currentView = mappedView
  }

  const showAuthModal = (currentView: AuthModalView) => {
    changeViewHandler(currentView)
    authModal.value.isShow = true
  }

  const hideAuthModal = () => {
    authModal.value.isShow = false
  }

  return { authModal, showAuthModal, hideAuthModal }
})

export const useAuthModalStore = useAuthModal

